import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import RFIsContext from '../../redux/RFIsContext';
import ErrorBoundary from 'react-error-boundary';
import AppLoading from './AppLoading';
import '../../assets/styles/app.scss';
import { historyAttributesType, storeAttributesType } from '../../constants/proptype-validation';
import cx from 'classnames';
import { viewTypes } from '../../constants/view-types';
import { LocaleProvider } from '@adsk/bim360-matrix-react-components';

class ReduxProvider extends PureComponent {

  getContainerComponent() {
    const { DevTools, store, history, viewType, locale } = this.props;
    const fixModalOffset = navigator.userAgent.indexOf('Edge') >= 0 && viewType === viewTypes.DOCUMENT;
    const rootElementClassName = cx('rfis-root-element', `rfis-root--${viewType}`, {
      'rfis-root-element--modal-offset-fix': fixModalOffset,
    });

    return (
      <Provider store={store} context={RFIsContext}>
        <div className={rootElementClassName}>
          <LocaleProvider locale={locale}>
            <AppLoading history={history} />
          </LocaleProvider>
          {DevTools ? <DevTools store={store} /> : null}
        </div>
      </Provider>
    );
  }

  render() {
    if (this.props.onError) {
      return <ErrorBoundary onError={this.props.onError}>{this.getContainerComponent()}</ErrorBoundary>;
    }
    else {
      return this.getContainerComponent();
    }

  }
}

ReduxProvider.propTypes = {
  store: storeAttributesType.isRequired,
  history: historyAttributesType.isRequired,
  DevTools: PropTypes.func,
  onError: PropTypes.func,
  viewType: PropTypes.string,
  locale: PropTypes.string.isRequired,
};

ReduxProvider.displayName = 'ReduxProvider';

export default ReduxProvider;
